import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteUserById, fetchUserByStatus, getUsersList } from '../../../redux/actions/Actions'
import { Box, IconButton, Stack } from '@mui/material'
import { Delete, Edit } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid'

const UserList = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const fetchUsersList = useSelector((state) => state.getAllUsers.allUsers)
  const fetchUserListByStatus = useSelector((state) => state.getUserByStatus.userByStatus)
  const { user } = useSelector((state) => state.auth)
  
  const [userStatus, setUserStatus] = useState('')
  const [data, setData] = useState([])

  function formatDate(dt) {
    const date = new Date(dt)
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
  }

  const handleDelete = (id) => {
    dispatch(deleteUserById(id))
    console.log('Deleted User ID:', id)
  }

  const columns = useMemo(() => [
    { field: 'id', headerName: 'Id', width: 80 },
    { field: 'role', headerName: 'Role', width: 100 },
    { field: 'email', headerName: 'Email', width: 180 },
    { field: 'phone_number', headerName: 'Phone Number', width: 150 },
    { field: 'status', headerName: 'Status', width: 140 },
    { field: 'date', headerName: 'Date', width: 140 },
    {
      field: 'action',
      headerName: 'Actions',
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const currentRow = params.row

        const handleEdit = () => {
          navigate(`/Auth/updateUser/${currentRow.user_id}`)
        }

        const handleDeleteClick = () => {
          handleDelete(currentRow.user_id)
        }

        return (
          <Stack direction="row" spacing={1}>
            <IconButton onClick={handleEdit}>
              <Edit />
            </IconButton>
            {
              currentRow.role_id !== 1 ?
                <IconButton onClick={handleDeleteClick}>
                  <Delete />
                </IconButton>
                :
                <IconButton disabled>
                  <Delete />
                </IconButton>
            }
          </Stack>
        )
      },
    }
  ], [])

  const rows = useMemo(() =>
    data?.map((row) => ({
      ...row,
      id: row.user_id,  // ✅ unique ID for DataGrid
      role: row.role_name,
      program_name: row.subprogram_name,
      date: formatDate(row.modify_date)
    })), [data])

  useEffect(() => {
    setUserStatus(props.status)
    dispatch(getUsersList())
  }, [dispatch, props.status])

  useEffect(() => {
    if (userStatus) {
      dispatch(fetchUserByStatus(userStatus))
    }
  }, [dispatch, userStatus])

  useEffect(() => {
    if (userStatus === 'all') {
      setData(fetchUsersList)
    } else {
      setData(fetchUserListByStatus)
    }
  }, [userStatus, fetchUsersList, fetchUserListByStatus])

  return (
    <div className='user-list'>
      <Box>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
        />
      </Box>
    </div>
  )
}

export default UserList
